module.exports = __webpack_public_path__ + "fonts/CalibreLight.ed571050.woff";